import { watch } from "vue";

/**
 * 按输入内容推断服务端查询类型：
 * - 含 @ → email
 * - 去空格后长度 20 → task_id
 * - 其余 → user_id
 */
export function inferAdminQueryType(value) {
  const normalized = String(value ?? "").trim();
  if (!normalized) return null;
  if (normalized.includes("@")) return "email";
  if (normalized.length === 20) return "task_id";
  return "user_id";
}

export function normalizeAdminQueryValue(type, value) {
  const normalized = String(value ?? "").trim();
  if (type === "email") return normalized.toLowerCase();
  return normalized;
}

/** 提交前同步推断类型并规范化输入 */
export function prepareAdminQuerySubmit(adminQueryInput, adminQueryType) {
  let normalizedValue = normalizeAdminQueryValue(
    adminQueryType.value,
    adminQueryInput.value
  );
  const inferred = inferAdminQueryType(normalizedValue);
  if (inferred) {
    adminQueryType.value = inferred;
  }
  normalizedValue = normalizeAdminQueryValue(
    adminQueryType.value,
    normalizedValue
  );
  adminQueryInput.value = normalizedValue;
  return normalizedValue;
}

/** 输入时自动切换 Task ID / User ID / Email 选项 */
export function useAdminQueryTypeAutoDetect(adminQueryInput, adminQueryType) {
  watch(adminQueryInput, (value) => {
    const inferred = inferAdminQueryType(value);
    if (inferred) {
      adminQueryType.value = inferred;
    }
  });
}
